<template>
  <v-container class="pb-0">
    <!-- <span>{{ itemHistoryTaking }}</span> -->
    <v-row>
      <v-col cols="12">
        <v-row
          v-if="itemHistoryTaking !== null"
          class="pa-0 ma-0"
          style="border: 1px solid #e5e5e5; border-radius: 10px"
        >
          <v-col
            cols="12"
            class="d-flex"
            align-self="center"
            style="height: 60px; border-bottom: 1px solid #e5e5e5"
          >
            <span class="pt-2 w-600 font-16 text-navy-50"
              >ข้อมูลการซักประวัติ
            </span>
          </v-col>
          <v-col cols="12" lg="12" class="d-flex flex-column mb-1">
            <div>
              <span class="w-300 font-14 text-navy-50">อาการสำคัญ</span>
              <v-text-field
                class="w-300 font-14"
                solo
                dense
                readonly
                :value="
                  itemHistoryTaking.marjor_symptoms
                    ? itemHistoryTaking.marjor_symptoms
                    : '-'
                "
              />
            </div>
            <div>
              <span class="w-300 font-14 text-navy-50">อาการปัจจุบัน </span>
              <v-text-field
                class="w-300 font-14"
                solo
                dense
                readonly
                :value="
                  itemHistoryTaking.current_symptoms
                    ? itemHistoryTaking.current_symptoms
                    : '-'
                "
              />
            </div>
            <div>
              <span class="w-300 font-14 text-navy-50">โรคประจำตัว</span>
              <v-text-field
                class="w-300 font-14"
                solo
                dense
                readonly
                :value="
                  itemHistoryTaking.congenital_disease
                    ? itemHistoryTaking.congenital_disease
                    : '-'
                "
              />
            </div>
            <div>
              <span class="w-300 font-14 text-navy-50">บันทึกทางการแพทย์</span>
              <v-text-field
                class="w-300 font-14"
                solo
                dense
                readonly
                :value="
                  itemHistoryTaking.medical_record
                    ? itemHistoryTaking.medical_record
                    : '-'
                "
              />
            </div>
          </v-col>
        </v-row>
        <v-row v-else class="pa-3">
          <v-col cols="12" class="noitems d-flex justify-center align-center">
            <h2>ไม่มีข้อมูลการซักประวัติ</h2>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      patient: {
        marjor_symptoms: "",
        current_symptoms: "",
        congenital_disease: "",
        medicalRecord: "",
      },
      selectYear: 2021,
      selectMonth: 0,
      // patient: [],
      months: [
        { value: 0, text: "ทั้งหมด" },
        { value: "01", text: "มกราคม" },
        { value: "02", text: "กุมภาพันธ์" },
        { value: "03", text: "มีนาคม" },
        { value: "04", text: "เมษายน" },
        { value: "05", text: "พฤษภาคม" },
        { value: "06", text: "มิถุนายน" },
        { value: "07", text: "กรกฎาคม" },
        { value: "08", text: "สิงหาคม" },
        { value: "09", text: "กันยายน" },
        { value: 10, text: "ตุลาคม" },
        { value: 11, text: "พฤศจิกายน" },
        { value: 12, text: "ธันวาคม" },
      ],
      selectedItem: 0,
      // items: [
      //   { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-1" },
      //   { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-2" },
      //   { date: "10 เมษายน 2564", time: "09:00 - 09:30 น.", value: "text-3" },
      // ],
      itemsICD10: 1,
      itemsICD9: 1,
      itemsDiagnisis: [
        { value: "L30", text_en: "Dermatitis", text_th: "ผิวหนังอักเสบ" },
        { value: "L70", text_en: "Acne", text_th: "สิว" },
        { value: "L40", text_en: "Psoriasis", text_th: "โรคสะเก็ดเงิน" },
        {
          value: "L21",
          text_en: "Seborrhoeic   dermatitis",
          text_th: "ผิวหนังอักเสบแบบรังแค",
        },
        { value: "L28", text_en: "prurigo", text_th: "พรูไรโก" },
        { value: "B35", text_en: "Tinea ", text_th: "โรคติดเชื้อรา" },
        {
          value: "L23",
          text_en: "Allergic contact dermatitis",
          text_th: "ผิวหนังอักเสบจากสัมผัสภูมิแพ้",
        },
        { value: "L81", text_en: "Chloasma", text_th: "ฝ้า" },
        { value: "L50", text_en: "Urticaria", text_th: "ลมพิษ  " },
        { value: "L63", text_en: "Alopecia", text_th: "ผมร่วง" },
        { value: "-", text_en: "Other", text_th: "อื่นๆ" },
      ],
    };
  },
  created() {
    console.log("this.detailQueue", this.detailQueue);
    if (this.detailQueue !== 0) {
      this.getPatient(this.detailQueue[0]);
    }
  },
  props: {
    reset: { type: Boolean, default: true },
  },
  watch: {
    reset() {
      this.reset_data();
    },
  },
  async mounted() {},
  computed: {
    ...mapState(["detailQueue", "itemHistoryTaking"]),
    ...mapGetters({
      items: "setDetailQueue",
      view: "viewHistoryTalkingGetter",
      currentPatient: "currentPatientGetter",
    }),

    itemYear() {
      // console.log(moment().year());
      let y = [];
      y.push({ value: moment().year() - 1, text: moment().year() - 1 + 543 });
      y.push({ value: moment().year(), text: moment().year() + 543 });
      y.push({ value: moment().year() + 1, text: moment().year() + 1 + 543 });

      // console.log(y);
      return y;
    },
    totalCD9() {
      // if (this.items[this.selectedItem].icd9 === null) return 1
      const total = this.items.result[this.selectedItem].icd9.length;
      if (total === 0) return 1;
      return total;
    },
    totalCD10() {
      // if (this.items[this.selectedItem].icd10 === null) return 1
      const total = this.items.result[this.selectedItem].icd10.length;
      if (total === 0) return 1;
      return total;
    },
  },
  methods: {
    closePage() {
      // this.$store.state.personalPatientDialog = false;
      this.$emit("close");
      this.reset_data();
    },
    reset_data() {
      this.selectYear = moment().year();
      this.selectMonth = 0;
      this.selectedItem = 0;
    },
    convertDate(date) {
      // console.log(date_diagnotic);
      var year1 = moment(date).locale("th").format("YYYY");
      var year2 = (parseInt(year1) + 543).toString();
      return moment(date)
        .locale("th")
        .format("DD MMMM " + year2);
    },
    convertTime(date) {
      // var year1 = moment(date).locale("th").format("YYYY");
      // var year2 = (parseInt(year1) + 543).toString();
      return moment(date).locale("th").format("hh:mm");
    },
    filter() {
      // const { patient_id: id } = this.items[this.selectedItem]
      let dateMonth = this.selectMonth;
      if (this.selectMonth === 0) dateMonth = "";
      this.$store.dispatch("getMedicalHistoryAction", {
        patient_id: this.currentPatient,
        dentist_clinic_id: sessionStorage.dentist_clinic_id,
        year: this.selectYear,
        month: dateMonth,
      });
      this.selectedItem = 0;
    },
    diagnisis(value) {
      if ("diagnisis" in value && value.diagnisis.length != 0) {
        const text = value.diagnisis.map((item) => {
          return item["text_en"];
        });
        return String(text);
      } else {
        return "-";
      }
    },
    // async getPatient(item) {
    //   const params = new URLSearchParams();
    //   // params.append("clinic_id", "06");
    //   params.append("biz_id", sessionStorage.biz_id);
    //   params.append("search", item.patient_id);
    //   params.append("limit", 100);
    //   params.append("page", 1);
    //   // params.append("status_drug", this.drug_status);

    //   await this.axios
    //     .get(
    //       `${process.env.VUE_APP_BACKEND_URL}/v1/diagnostic-histories/patient?${params}`
    //     )
    //     .then((res) => {
    //       console.log(res);
    //       this.patient = res.data.data[0].data;
    //       console.log("patientllllllllllll: ", this.patient);
    //     });
    // },
    getPatient(item) {
      console.log(item);
      if (item) {
        this.patient = JSON.parse(JSON.stringify(item));
        this.patient = item;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.left-content {
  width: 45%;
}
.right-content {
  width: 55%;
  // height: 100vh;
  margin-top: -12px;
  // margin-bottom: -12px;
  border-left: 1px solid #babdbf;
}
.v-list-item-group .v-list-item--active {
  color: #fff;
  background: #00a99d;
}
.v-list-item {
  background: #e8f6f7;
  color: #000;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.noitems {
  height: 77vh;
  border: 1px solid #e8e9e9;
  border-radius: 10px;
}

::v-deep
  .v-text-field--outlined.v-input--dense.v-text-field--outlined
  > .v-input__control
  > .v-input__slot {
  min-height: 32px;
}

::v-deep
  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(
    .v-input--has-state
  )
  > .v-input__control
  > .v-input__slot
  fieldset {
  border: 1px solid #e8e9e9;
}

::v-deep .v-select__selections {
  min-height: 32px;
}

::v-deep .theme--light.v-chip:not(.v-chip--active) {
  background: #e0edfa;
}

::v-deep .v-chip--disabled {
  opacity: 1 !important;
}
</style>
